import React from 'react';
import { Link } from 'react-router-dom';

export function PublicFooter() {
  return (
    <footer className="border-t border-[#E8E4DC] bg-[#FAFAF8]" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <p className="font-serif text-lg text-[#1A1A1A] mb-3">V&Eacute;RAULT Travels</p>
            <p className="text-sm text-[#6B6B6B] leading-relaxed">
              Travel designed as a form of refinement.
            </p>
          </div>

          {/* Explore */}
          <div>
            <p className="text-xs uppercase tracking-[0.15em] text-[#999] mb-4">Explore</p>
            <div className="flex flex-col gap-2">
              <Link to="/destinations" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">Destinations</Link>
              <Link to="/services" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">Services</Link>
              <Link to="/blog" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">Journal</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <p className="text-xs uppercase tracking-[0.15em] text-[#999] mb-4">Company</p>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">Philosophy</Link>
              <Link to="/plan" className="text-sm text-[#6B6B6B] hover:text-[#1A1A1A]">Begin Your Experience</Link>
            </div>
          </div>

          {/* Wave 12.q — Suite Access block removed.
              Advisors enter via /owner-access on travel.verault.co.
              Clients enter via their suite-landing door slug. */}
        </div>

        <div className="mt-12 pt-6 border-t border-[#E8E4DC] text-center">
          <p className="text-xs text-[#999]">&copy; {new Date().getFullYear()} V&Eacute;RAULT Travels. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
